module.exports = __webpack_public_path__ + "static/img/IMG_20241028_170536.391785bd.jpg";